import React from 'react';
interface ScheduleWarningTextProps {
  color?: string;
  children: React.ReactNode;
}

const ScheduleWarningText: React.FC<ScheduleWarningTextProps> = ({ color, children }) => (
  <span style={{ color: color || 'inherit' }}>
    {children}
  </span>
);

export default ScheduleWarningText;
